module.exports = __webpack_public_path__ + "static/mobile-click-flooding-682ac8002924421199ff9aed71e39bab.gif";